import React, { Component, Fragment } from 'react';
import Header from "./Header";

class AuthLayout extends Component {

    render() {
        const { children, className } = this.props;
        return (
            <Fragment>
                <Header />
                <main className={`auth-all-content ${(className && className) ? className : ''}`}>
                    {children}
                </main>
            </Fragment>
        );
    }
}

export default AuthLayout;
